import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns accounts with operations pending signature
@return { Array }
*/
export const getAccountsWithOperationsPendingSignature = state => state.accountsWithOperationsPendingSignature

/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}

/** returns accounts list
@return { Array }
*/
export const getAccountsList = state => {
    return state.accountsList
}

/** returns profiles list
@return { Array }
*/
export const getProfilesList = state => {
    return state.profilesList
}

/** returns operator details
@return { Array }
*/
export const getOperatorDetails = state => {
    return state.operatorDetails
}

/** returns total number of operations to sign
@return { Number }
*/
export const getTotalNumberOfOperationsToSign = state => {
    return state.totalNumberOfOperationsToSign
}

/** returns operations types List
@return { Array }
*/
export const getOperationsTypesList = state => {
    return state.operationsTypesList
}
